import React, { useEffect, useState } from 'react';
import { Nullable } from 'src/types/nullable.type';

interface Step {
  label: string;
  duration: number;
}

export const CreateJourneyStatus = ({ steps, duration }: { steps: Step[]; duration: number }) => {
  const [currentStep, setCurrentStep] = useState<Nullable<{ label: string; duration: number }>>(null);

  useEffect(() => {
    let timeout: Nullable<ReturnType<typeof setTimeout>> = null;
    let stepIndex = 0;
    const runStep = () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      const step = steps[stepIndex];
      setCurrentStep(step);
      timeout = setTimeout(() => {
        stepIndex++;
        if (stepIndex < steps.length) {
          runStep();
        }
      }, step.duration * duration);
    };
    runStep();
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  if (!currentStep) {
    return null;
  }

  return <span className='text-neue-journey-small text-inherit'>{currentStep.label}</span>;
};
